import locationImage from 'assets/images/eventBoatRacingT10/location.png'
import rankEndHeadImage from 'assets/images/eventBoatRacingT10/rank-end-head.png'
import top1Image from 'assets/images/eventBoatRacingT10/top1.png'
import top2Image from 'assets/images/eventBoatRacingT10/top2.png'
import top3Image from 'assets/images/eventBoatRacingT10/top3.png'
import xiaomiredmi14Image from 'assets/images/eventBoatRacingT10/xiaomiredmi14.png'
import image1K from 'assets/images/eventBoatRacingT10/1.webp'
import image500 from 'assets/images/eventBoatRacingT10/5.webp'
import { getCheckEventBoatRacing102025Query, getEventBoatRacing102025Rank } from 'dataLayer/game'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

const Ranks = ({ data, limit }) => {
	const { t } = useTranslation()

	const renderNo = (no) => {
		if (no === 1) return <img src={top1Image} alt="top1" width={27} height={32} />
		if (no === 2) return <img src={top2Image} alt="top2" width={27} height={32} />
		if (no === 3) return <img src={top3Image} alt="top3" width={27} height={32} />
		return no
	}

	const topRanks = data?.ranks?.data || []
	const myRank = data?.myRank

	return (
		<>
			<span className="text-detail">{t('event.event_boa_racing_t10.rank')}</span>
			<div className="list-rank">
				<div className={`rank-row padding-row header-rank ${limit == 0 && 'is-data'}`}  >
					<div>{t('event.event_boa_racing_t10.no')}</div>
					<div>{t('event.event_boa_racing_t10.number_of_boats')}</div>
					<div>{t('event.event_boa_racing_t10.nick_name')}</div>
					<div>{t('event.event_boa_racing_t10.subscribers')}</div>
				</div>

				<div className={limit == 0 ? 'list-item-ranks-all' : "list-item-ranks"}>
					{topRanks.map((item, index) => {
						const displayName =
							item?.full_name?.length > 17
								? item.full_name.slice(0, 17) + "***"
								: item?.full_name || "";

						return (<div key={index} className="rank-row padding-row">
							<div>{renderNo(index + 1)}</div>
							<div>{item?.boat_number}</div>
							<div>{displayName}</div>
							<div>{item?.msisdn}</div>
						</div>)
					}

					)}
				</div>
				{limit == 0 ? "" :
					<>
						{topRanks?.length >= 6 &&
							<div className="rank-row padding-row">
								<div>...</div>
								<div>...</div>
								<div>...</div>
								<div>...</div>
							</div>
						}</>
				}
				{data?.myRank ?
					<div className={`rank-row my-rank ${limit == 0 && 'is-data'}`}>
						<div>
							<img src={locationImage} alt="my-location" className="my-location" />
							{myRank?.position}
						</div>
						<div>{myRank?.boat_number}</div>
						<div>{myRank?.full_name?.length > 17
							? myRank.full_name.slice(0, 17) + "***"
							: myRank?.full_name || ""}</div>
						<div>{myRank?.msisdn}</div>
					</div>
					: ''
				}
			</div>
		</>
	)
}

const RankEnd = ({ topRanks, onSeeDetail }) => {
	const { t } = useTranslation()
	const topImages = [top1Image, top2Image, top3Image]
	const prizeImages = [xiaomiredmi14Image, image1K, image500]

	return <div className='rank-end'>
		<div className='rank-end-head'>
			<img src={rankEndHeadImage} alt="rank-end-head" className='rank-end-head-image' />
			<p className='rank-end-head-text'>Boun Suang Heua Campigain Winner</p>
		</div>
		<div className='rank-end-content'>
			{[0, 1, 2].map((index) => {
				const winner = topRanks?.[index]
				return (
					<div className='items' key={index} style={index > 0 ? { marginTop: 8 } : undefined}>
						<div className='items-right'><img src={topImages[index]} alt={`top${index + 1}`} style={{ width: 25, maxWidth: 'none', flex: '0 0 20px', objectFit: 'contain' }} /></div>
						<div className='items-left'>
							<img src={prizeImages[index]} alt={`prize${index + 1}`} className={index > 0 ? 'rank-end-head-image prize-big' : 'rank-end-head-image'} />
							<div>
								<p>{winner?.full_name ?? ""}</p>
								<p>{winner?.msisdn ?? ""}</p>
							</div>
						</div>
					</div>
				)
			})}
		</div>
		<div className='rank-end-footer'>
			<p>
				{t('event.event_boa_racing_t10.boun_suang_heua_event_has_ended_above_is_the_list_of_users_who_won_prizes_from_this_offer_please_continue_to_experience_and_look_forward_to_upcoming_campaigns_from_arabica')}
			</p>
			<button onClick={() => onSeeDetail()}>{t('event.event_boa_racing_t10.see_detail')}</button>
		</div>
	</div>
}

export default function BoatRacingRankT10() {
	const [showDetail, setShowDetail] = useState(false)
	const [limit, setLimit] = useState(6)

	const {
		data: rankRacing102025,
		refetch: fetchEventBoatRacing102025Rank,
	} = useQuery(
		getEventBoatRacing102025Rank({
			my_rank: 1,
			limit,
		})
	)
	console.log(rankRacing102025);

	const { data: eventBoatRacing102025, refetch: refetchEventBoatRacing102025 } = useQuery(
		getCheckEventBoatRacing102025Query(),
	)

	useEffect(() => {
		refetchEventBoatRacing102025()
	}, [])

	useEffect(() => {
		fetchEventBoatRacing102025Rank()
	}, [limit])

	const endDate = new Date(`${eventBoatRacing102025?.end_time_finish}T23:59:59`);
	const now = new Date()
	const isEnded = now > endDate

	if (!eventBoatRacing102025?.end_time_finish) {
		return null
	}

	return (
		<div className="boat-racing-rank-t10">
			<div className="content-rank">
				{isEnded ? (
					showDetail ? (
						<Ranks data={rankRacing102025} limit={limit} />
					) : (
						<RankEnd
							topRanks={rankRacing102025?.ranks?.data}
							onSeeDetail={() => {
								setShowDetail(true)
								setLimit(0)
							}}
						/>
					)
				) : (
					<Ranks data={rankRacing102025} limit={limit} />
				)}
			</div>
		</div>
	)
}